import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=687809aa&scoped=true"
import script from "./mobile-header.vue?vue&type=script&lang=js"
export * from "./mobile-header.vue?vue&type=script&lang=js"
import style0 from "./mobile-header.vue?vue&type=style&index=0&id=687809aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687809aa",
  null
  
)

export default component.exports